import Category from '@/models/Category';

export default {
  computed: {
    category() {
      return (this.model ? Category.find(this.model.category) : null) || new Category();      
    },

    name() {
      return this.model ? this.model.name : '';
    },

    // I think this replaces name()
    breadcrumbLabel() {
      return this.model ? this.model.name : '';
    }
  }
}